import { mainNetDecimal, providerUrl, testNetDeciaml } from 'config/config';
import gearNftContractAbi from 'config/gear-nft-contract-abi';
import gearTokenContractAbi from 'config/gear-token-contract-abi';
import { toBigInt } from 'ethers';
import { option, perLogger } from 'utils/per-logger';
import Web3 from 'web3';

const web3 = new Web3(providerUrl);
const contractABI = gearNftContractAbi; // NFT 컨트랙트 ABI
const tokenContractABI = gearTokenContractAbi; // 토큰 컨트랙트 ABI

const gasPriceInWei = web3.utils.toWei('500', 'gwei');

export const callApprove = async ({
  address,
  chainId,
  price,
  gearTokenContractAddress,
  gearContractAddress,
}) => {
  const provider = new Web3(window.ethereum);

  // 토큰 컨트랙트 인스턴스 생성
  const tokenContractAddress = gearTokenContractAddress;
  const tokenContract = new provider.eth.Contract(
    tokenContractABI,
    tokenContractAddress,
  );

  // 판매 컨트랙트 주소
  const saleContractAddress = gearContractAddress;

  // 기어 가격
  const decimal = chainId === 80002 ? testNetDeciaml : mainNetDecimal;
  const approvalAmount = toBigInt(price.toString()) * decimal; // 10800 * (10 ** 6) 토큰

  await tokenContract.methods
    .approve(saleContractAddress, approvalAmount)
    .send({ from: address, gasPrice: gasPriceInWei });
};

// 기어 한 개당 한번씩 호출해 줘야 한다.
export const callExchange = async ({
  address,
  saleId,
  code,
  contractAddress,
}) => {
  try {
    const provider = new Web3(window.ethereum);
    const contract = new provider.eth.Contract(contractABI, contractAddress);

    // exchange 함수 호출
    const result = await contract.methods
      .exchange(saleId, code ?? '')
      .send({ from: address, gas: 500000, gasPrice: gasPriceInWei });
    perLogger.log(`Exchange Result: ${result}`, {
      ignore: [option.prod],
      consoleMode: true,
    });
    return result;
  } catch (error) {
    console.error('Error:', error);
    return { error: error };
  }
};

// 남은 개수 확인
export const callMintable = async ({ saleId, contractAddress }) => {
  if (!saleId) {
    throw new Error('saleId is undifined');
  }
  if (!contractAddress) {
    throw new Error('contract address is undifined');
  }
  const contract = new web3.eth.Contract(contractABI, contractAddress);
  const amount = await contract.methods.mintable(saleId).call();
  perLogger.log(`남은 수량: ${amount * 10} [id: ${saleId}]`, {
    ignore: [option.prod],
    consoleMode: true,
  });
  return Number(amount);
};

export const callGetSupply = async (saleId, contractAddress) => {
  const contract = new web3.eth.Contract(contractABI, contractAddress);
  const res = await contract.methods.getSupply(saleId).call();
  perLogger.log(`Sale Schedule Info: ${res}`, {
    ignore: [option.prod],
    consoleMode: true,
  });
  return res;
};

// 밸런스 획득.
export const callBalence = async ({
  chainId,
  address,
  gearTokenContractAddress,
}) => {
  try {
    const provider = new Web3(window.ethereum);

    // 토큰 컨트랙트 인스턴스 생성
    const tokenContractAddress = gearTokenContractAddress; // 아모이 테스트용 컨트랙트
    // 위 컨트랙트 주소는 따로 받아서 처리해야 함 (테스트용/라이브용)
    const tokenContract = new provider.eth.Contract(
      tokenContractABI,
      tokenContractAddress,
    );

    const decimal = chainId === 80002 ? testNetDeciaml : mainNetDecimal;

    const result = await tokenContract.methods.balanceOf(address).call();
    return toBigInt(result) / decimal;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

// 각 saleId 별 판매량
export const callSaleInfo = async (saleId, contractAddress) => {
  const contract = new web3.eth.Contract(contractABI, contractAddress);
  const res = await contract.methods.getSaleScheduleInfo(saleId).call();
  perLogger.log(
    `판매량: [요청: ${saleId}][ID: ${res.saleId}][수량: ${res.exchangedCount}]`,
    {
      ignore: [option.prod],
      consoleMode: true,
    },
  );
  return Number(res.exchangedCount) ?? 0;
};
